import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7226a9d5&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=7226a9d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7226a9d5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextPressure: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/text-pressure.vue').default,AuroraBackground: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/aurora-background.vue').default,PageBottom: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/page-bottom/index.vue').default})
